import {
    Box,
    AppBar,
    Toolbar,
    Stack,
    List,
    Tab,
    Tabs,
    IconButton,
    useMediaQuery,
    Drawer,
    Divider,
    Avatar,
    Menu,
    MenuItem,
} from '@mui/material'
import pxToRem from '../../helpers/pxToRem'
import styles from './DashboardHeader.module.scss'
import sparkIcon from '../../assets/images/header/Spark Relief Teachers Logo.png'
import { useLocation, useNavigate } from 'react-router-dom'
import a11yProps from '../../helpers/a11yProps'
import { useEffect, useMemo, useState } from 'react'
import { DashboardTabNames, TabNames } from '../../routers/type'
import { DrawerIcon } from './helper'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'

import HomeIcon from '@mui/icons-material/Home'
import LogoutIcon from '@mui/icons-material/Logout'
import SettingsIcon from '@mui/icons-material/Settings'
import HelpCenterIcon from '@mui/icons-material/HelpCenter'
import MenuIcon from '@mui/icons-material/Menu'
import sparkLogo from '../../assets/images/share/sparkIcon.png'
import useSignOutUser from '../../hooks/useSignOutUser'
import { tabNames } from '../../routers/helpers'

const getMenuItems = (centreId: string) => [
    {
        label: 'Home',
        name: '',
        link: `${tabNames.app.centre.index}/${centreId}`,
        icon: <HomeIcon />,
    },
    {
        label: 'My Centre',
        name: 'my-centre',
        link: `${tabNames.app.centre.index}/${centreId}/${DashboardTabNames.MY_CENTRE}`,
    },
    {
        label: 'Help Desk',
        name: 'help',
        link: `/${TabNames.HELP_DESK}`,
        icon: <HelpCenterIcon />,
    },
    {
        label: 'Settings',
        name: 'settings',
        link: `${tabNames.app.centre.index}/${centreId}/${DashboardTabNames.SETTINGS}`,
        icon: <SettingsIcon />,
    },
]

const findTab = (menuItems: any[], path: string | undefined) =>
    path === undefined || path === ''
        ? 0
        : menuItems.findIndex(
              (el) => el.link.substring(el.link.lastIndexOf('/') + 1) === path
              //   ||(el.otherKeys && el.otherKeys.includes(path))
          )

const CentreHeader = ({ centreId }: { centreId?: string }) => {
    const navigate = useNavigate()
    const location = useLocation()
    // const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isMobile = useMediaQuery('(max-width: 1000px')
    const [drawerOpen, setDrawerOpen] = useState(false)

    const isUserData = useSelector((state: RootState) => !!state.user.user.data)
    const profilePictureURL = useSelector(
        (state: RootState) => state.user.user.data?.profilePictureURL
    )

    const path = location.pathname.split('/').at(4)

    const MENU_ITEMS = useMemo(
        () => (centreId ? getMenuItems(centreId) : []),
        [centreId]
    )
    const [selectedTab, setSelectedTab] = useState<number>(
        findTab(MENU_ITEMS, path)
    )

    const onTabChangeSchool = (_: React.SyntheticEvent, newValue: number) => {
        if (newValue >= 0 && newValue < MENU_ITEMS.length) {
            navigate(MENU_ITEMS[newValue].link)
        }
    }

    useEffect(() => {
        setSelectedTab(findTab(MENU_ITEMS, path))
    }, [MENU_ITEMS, path])

    const [signOutUser] = useSignOutUser()
    const handleLogout = async () =>
        // await signOutUser(dispatch, () => navigate('/'))
        signOutUser(() => navigate('/'))

    const [anchorEl, setAnchorEl] = useState<null | Element>(null)
    const handleMenu = (event: React.MouseEvent<Element>) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }

    const HamburgerMenu = () => (
        <Drawer
            open={drawerOpen}
            anchor={'right'}
            onClose={() => setDrawerOpen(!drawerOpen)}
        >
            <List sx={{ paddingTop: '40px' }}>
                <Tabs
                    key={`centreHeader_tabs`}
                    orientation={'vertical'}
                    value={
                        selectedTab >= 0 && selectedTab <= 3
                            ? selectedTab
                            : false
                    }
                    onChange={(e, newValue) => {
                        onTabChangeSchool(e, newValue)
                        setDrawerOpen(false)
                    }}
                    sx={{
                        '& .MuiTab-root.Mui-selected': {
                            color: styles.primary500,
                            fontWeight: isMobile ? 600 : 700,
                        },
                    }}
                >
                    {MENU_ITEMS.map((el, i) => (
                        <Tab
                            key={`centreHeader_tab_${i}`}
                            sx={{ '&.MuiTab-root': { alignItems: 'flex-end' } }}
                            aria-label={el.name}
                            label={DrawerIcon(el.label, el.icon)}
                            className={styles.hamburgerTab}
                            {...a11yProps(i)}
                        />
                    ))}
                    <Divider sx={{ width: '80%', alignSelf: 'center' }} />
                    <Tab
                        sx={{ '&.MuiTab-root': { alignItems: 'flex-end' } }}
                        aria-label="logout"
                        label={DrawerIcon('Logout', <LogoutIcon />)}
                        className={styles.hamburgerTab}
                        onClick={handleLogout}
                    />
                </Tabs>
            </List>
        </Drawer>
    )

    return (
        <Box sx={{ backgroundColor: '#fff' }}>
            <AppBar
                position="static"
                sx={{
                    // height: '100%',
                    padding: `${pxToRem(0)} ${pxToRem(20)}`,
                    backgroundColor: 'inherit',
                    boxShadow: 'inset 0px -1px 0px 0px #F0F0F0',
                }}
            >
                <Toolbar variant="dense">
                    <img
                        className={styles.icon}
                        src={sparkIcon}
                        alt="Spark Icon (Text only)"
                        onClick={() => navigate(`/`)}
                    />
                    <Stack ml={'auto'}>
                        {isMobile ? (
                            <>
                                <IconButton onClick={() => setDrawerOpen(true)}>
                                    <MenuIcon />
                                </IconButton>
                                <HamburgerMenu />
                            </>
                        ) : (
                            <List sx={{ padding: 0 }}>
                                <Tabs
                                    key={`schools_tabs`}
                                    value={
                                        selectedTab >= 0 && selectedTab <= 2
                                            ? selectedTab
                                            : false
                                    }
                                    onChange={onTabChangeSchool}
                                    slotProps={{
                                        indicator: {
                                            sx: {
                                                backgroundColor:
                                                    styles.secondaryBlue800,
                                                height: pxToRem(1),
                                                color: styles.secondaryBlue800,
                                                borderColor:
                                                    styles.secondaryBlue800,
                                            },
                                        },
                                    }}
                                    sx={{
                                        '& .MuiTabs-indicator': {
                                            // backgroundColor: styles.primaryBlue500,
                                            backgroundColor: 'none',
                                        },
                                        '& .MuiTab-root.Mui-selected': {
                                            color: styles.secondaryBlue800,
                                            border: 0,
                                            // fontWeight: isMobile ? 600 : 700
                                        },
                                        '& button': {
                                            borderRadius: 2,
                                            // margin: '6px',
                                            padding: pxToRem(12),
                                            transition: 'all 300ms',
                                        },
                                        '& button:hover': {
                                            background: 'none',
                                            color: styles.secondaryBlue300,
                                        },
                                        '& button:focus': {
                                            background: 'none',
                                        },
                                        '& button:active': {
                                            background: 'none',
                                        },
                                        '& button.Mui-selected': {
                                            background: 'none',
                                        },
                                        '& button.Mui-disabled': {
                                            // color: styles.neutrals200,
                                            color: 'blue',
                                            background: 'none',
                                        },
                                    }}
                                >
                                    <Tab
                                        key={`centre_tab_0`}
                                        aria-label={MENU_ITEMS[0].name}
                                        label={MENU_ITEMS[0].label}
                                        className={styles.hamburgerTab}
                                        {...a11yProps(0)}
                                    />
                                    ,
                                    <Tab
                                        key={`centre_tab_1`}
                                        aria-label={MENU_ITEMS[1].name}
                                        label={MENU_ITEMS[1].label}
                                        className={styles.hamburgerTab}
                                        {...a11yProps(1)}
                                    />
                                    ,
                                    <Tab
                                        key={`centre_tab_3`}
                                        aria-label={MENU_ITEMS[2].name}
                                        label={MENU_ITEMS[2].label}
                                        className={styles.hamburgerTab}
                                        {...a11yProps(2)}
                                    />
                                </Tabs>
                            </List>
                        )}
                    </Stack>
                    {!isMobile && isUserData ? (
                        <div>
                            <IconButton
                                size="large"
                                aria-label="account of current user"
                                aria-controls="menu-appbar"
                                aria-haspopup="true"
                                onClick={handleMenu}
                                color="inherit"
                                sx={{ marginLeft: pxToRem(40) }}
                            >
                                <Avatar
                                    src={profilePictureURL || sparkLogo}
                                    alt="User Photo"
                                />
                            </IconButton>
                            <Menu
                                id="menu-appbar"
                                anchorEl={anchorEl}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                keepMounted
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                                slotProps={{
                                    paper: {
                                        className: styles.dotButtonMenu,
                                    },
                                    list: {
                                        className: styles.menuListcontainer,
                                    },
                                }}
                            >
                                <MenuItem
                                    className={styles.hoverMenuItem}
                                    onClick={() => {
                                        handleClose()
                                        navigate(
                                            `${tabNames.app.centre.index}/${centreId}/${DashboardTabNames.SETTINGS}`
                                        )
                                    }}
                                >
                                    Settings
                                </MenuItem>
                                <MenuItem
                                    className={styles.hoverMenuItem}
                                    onClick={handleLogout}
                                >
                                    Logout
                                </MenuItem>
                            </Menu>
                        </div>
                    ) : null}
                </Toolbar>
            </AppBar>
        </Box>
    )
}

export default CentreHeader
